import { ISeat, ITabItem } from 'interfaces/tab'

export const itemsToSeat = (items: ITabItem[]) => {
  const seatList: ISeat[] = []
  if (items.length > 0) {
    const seats = items.map((d) => d.seatNumber)
    const distinctSeat = seats.filter((c, index) => {
      return seats.indexOf(c) === index
    })

    distinctSeat.forEach((element) => {
      const itemsInSeat = items.filter((d) => d.seatNumber === element)
      seatList.push({
        isPaid: false,
        isSelected: false,
        items: itemsInSeat,
        seatNumber: element,
      })
    })
  }
  return seatList
}
export const formatPhoneNumber = (value: string) => {
  // if input value is falsy eg if the user deletes the input, then just return
  if (!value) return value

  // clean the input for any non-digit values.
  const phoneNumber = value.replace(/[^\d]/g, '')

  // phoneNumberLength is used to know when to apply our formatting for the phone number
  const phoneNumberLength = phoneNumber.length

  // we need to return the value with no formatting if its less then four digits
  // this is to avoid weird behavior that occurs if you  format the area code to early

  if (phoneNumberLength < 4) return phoneNumber

  // if phoneNumberLength is greater than 4 and less the 7 we start to return
  // the formatted number
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`
  }

  // finally, if the phoneNumberLength is greater then seven, we add the last
  // bit of formatting and return it.
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6, 10)}`
}

export const generateRandomString = (length: number) => {
  let result = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
  const charactersLength = characters.length
  for (let iterator = 0; iterator < length; iterator += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

/**
 * Determines if there are available orders based on tab data
 * @param tabData - The tab data from /api/Tabs/get-tab-order-by-id
 * @returns boolean - true if there are available unpaid orders, false otherwise
 */
export const isOrderAvailableFromTabData = (tabData: any): boolean => {
  // Check if tabData exists and has orders
  if (
    !tabData ||
    !tabData.orders ||
    !Array.isArray(tabData.orders) ||
    tabData.orders.length === 0
  ) {
    return false
  }

  // Check if any order is open, not void, and has unpaid items
  return tabData.orders.some((order: any) => {
    // Skip if order is void or closed
    if (order.isVoid || !order.isOpen) {
      return false
    }

    // Check if order has items and at least one item is not paid
    if (order.items && Array.isArray(order.items) && order.items.length > 0) {
      return order.items.some((item: any) => !item.isPaid)
    }

    return false
  })
}

/**
 * Determines the correct route for "View Tab" button based on current state
 * @param tabDetailData - Tab detail data from Redux state
 * @param hasActiveOrder - Whether there's an active payment order (from OrderConfirmationService)
 * @returns string - The route path to navigate to
 */
export const getViewTabRoute = (): string => {
  // Always go to your-tab (removed cart redirect logic)
  return '/your-tab'
}

/**
 * Determines if ordering should be enabled based on both menu settings and table health
 * This combines isOrderingMenu flag from menus with table health status
 * @param menus - Array of menu data from Redux
 * @param paymentEnableData - Payment/health status data from Redux
 * @returns boolean - True if ordering should be enabled (shows Order Now), false otherwise (shows View Menu)
 */
export const isOrderingEnabledAndHealthy = (
  menus: any[],
  paymentEnableData: any
): boolean => {
  // Note: Removed table closed check - ordering remains enabled even when tab is closed

  // First check if menus have ordering enabled
  const hasOrderingMenus =
    menus && menus.some((menu) => menu.isActive && menu.isOrderingMenu)

  if (!hasOrderingMenus) {
    console.log('🍽️ No ordering menus available')
    return false // No ordering menus available
  }

  // Then check table health status - convert undefined to false for proper boolean logic
  const isTableHealthy =
    !!paymentEnableData?.status &&
    !paymentEnableData?.isTableDisable &&
    !!paymentEnableData?.isHealthy

  console.log('🏥 Health Check:', {
    status: paymentEnableData?.status,
    isTableDisable: paymentEnableData?.isTableDisable,
    isHealthy: paymentEnableData?.isHealthy,
    result: isTableHealthy,
  })

  // Both conditions must be true for ordering to be enabled
  const result = hasOrderingMenus && isTableHealthy
  console.log('✅ Final ordering decision:', result)

  return result
}
